import { QuoteBlockedReason, QuoteBlockedReasonItemLevel } from '@brenger/api-client';
import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useSelector } from 'react-redux';
import { FlashMessage } from '../../../brenger-shared-ui';
import { RootState } from '../../../types';
import cn from 'classnames';

export const BlockedReasonsFlash: React.FC<{ withReasons: boolean }> = ({ withReasons }) => {
  const blocked = useSelector((state: RootState) => state.generalTransport.quote?.blocked);
  if (!blocked?.result) return null;

  return (
    <FlashMessage type={'error'}>
      <div className={cn({ 'pb-[0.5em]': withReasons })}>
        <Translate id="is_blocked.generic_message" />
      </div>
      {withReasons && <BlockedReasonsSplittedList reasons={blocked.reasons} />}
    </FlashMessage>
  );
};

export const BlockedReasonsList: React.FC<{ reasons: (QuoteBlockedReason | QuoteBlockedReasonItemLevel)[] }> = ({
  reasons,
}) => {
  if (reasons.length === 1)
    return (
      <div>
        <Translate style={{ marginTop: '.25em' }} id={`is_blocked.reasons.${reasons[0]}`} />
      </div>
    );
  return (
    <>
      <ul style={{ marginTop: '.25em', marginBottom: '.1em', paddingLeft: '1em' }}>
        {reasons.map(r => (
          <li key={r}>
            <Translate id={`is_blocked.reasons.${r}`} />
          </li>
        ))}
      </ul>
    </>
  );
};

export const BlockedReasonsSplittedList: React.FC<{
  reasons: (QuoteBlockedReason | QuoteBlockedReasonItemLevel)[];
}> = ({ reasons }) => {
  const { itemSpecificReasons, globalReasons } = getSplittedBlockedReasons(reasons);
  return (
    <>
      {globalReasons.length === 1 && (
        <div style={{ marginBottom: itemSpecificReasons.length > 0 ? '.5em' : '0' }}>
          <Translate id={`is_blocked.reasons.${globalReasons[0]}`} />
        </div>
      )}
      {globalReasons.length > 1 && (
        <ul style={{ marginBottom: itemSpecificReasons.length > 0 ? '.5em' : '0' }}>
          {globalReasons.map(r => (
            <li key={r}>
              <Translate id={`is_blocked.reasons.${r}`} />
            </li>
          ))}
        </ul>
      )}
      {itemSpecificReasons.length > 0 && (
        <>
          <div>
            <Translate id="is_blocked.modal.item_specific_header" />
          </div>
          {itemSpecificReasons.length === 1 && <Translate id={`is_blocked.reasons.${itemSpecificReasons[0]}`} />}
          {itemSpecificReasons.length > 1 && (
            <ul>
              {itemSpecificReasons.map(r => (
                <li key={r}>
                  <Translate id={`is_blocked.reasons.${r}`} />
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </>
  );
};

interface SplittedBlockedReasons {
  itemSpecificReasons: QuoteBlockedReasonItemLevel[];
  globalReasons: QuoteBlockedReason[];
}

export const getSplittedBlockedReasons = (
  reasons: (QuoteBlockedReason | QuoteBlockedReasonItemLevel)[]
): SplittedBlockedReasons => {
  const itemSpecificReasons = reasons.filter(r => r.includes('item.') || r.includes('product_group.')) || [];
  const globalReasons = reasons.filter(r => !r.includes('item.') && !r.includes('product_group.')) || [];
  return { itemSpecificReasons, globalReasons } as SplittedBlockedReasons;
};
